import { AnimatedSkeletonList } from "@/components/common/AnimatedSkeletonList/AnimatedSkeletonList"
import InfoBox from "@/components/common/InfoBox/InfoBox"
import { SearchField } from "@/components/common/SearchField/SearchField"
import { StackedList } from "@/components/common/StackedList/StackedList"
import { toast } from "@/components/common/Toast"
import { QuestionnaireListItem } from "@/components/feature/QuestionnaireListItem/QuestionnaireListItem"
import { MainLayout } from "@/components/layout/MainLayout/MainLayout"
import { useTranslation } from "@/hooks/useTranslation/useTranslation"
import { useGetQuestionnairesData } from "@/services/api/questionnaireService"
import React, { useEffect, useMemo, useState } from "react"
import "react-loading-skeleton/dist/skeleton.css"
import ExtensionHistory from "./questionnaire/ExtensionHistory"

const QuestionnaireHistoryPage: React.FC = () => {
  const { translate } = useTranslation()
  const { data, isPending, isError } = useGetQuestionnairesData()
  const [search, setSearch] = useState("")

  useEffect(() => {
    if (isError) {
      toast.error(translate("HISTORY/TOAST_ERROR_GET_QUESTIONNAIRES"))
    }
  }, [isError, translate])

  const filteredData = useMemo(() => {
    if (!search) return data || []
    const query = search.toLocaleLowerCase()
    return (data || []).filter(
      (item) =>
        item.fileName.toLocaleLowerCase().includes(query) ||
        item.userName.toLocaleLowerCase().includes(query),
    )
  }, [data, search])

  return (
    <MainLayout
      titleInHeader
      title={translate("HISTORY/PAGE_TITLE")}
      contentCenter={
        <div className="space-y-6">
          <InfoBox.BestQuestionnaire />
          <SearchField
            value={search}
            onChange={setSearch}
            placeholder={translate("HISTORY/SEARCH_PLACEHOLDER")}
            onClear={() => setSearch("")}
          />
          {isPending ? (
            <AnimatedSkeletonList />
          ) : (
            <div data-agent-target="history.list">
              <StackedList
                items={filteredData}
                ItemComponent={QuestionnaireListItem}
                dataTestId="questionnaire-history-list"
              ></StackedList>
            </div>
          )}
          <ExtensionHistory search={search} />
        </div>
      }
    />
  )
}

export default QuestionnaireHistoryPage
